import "@/App.css";
import "./i18n"; // initialise i18next (must be imported before any t() calls)
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/AuthContext";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import LandingKids from "./pages/LandingKids";
import LandingUnified from "./pages/LandingUnified";
import PathChooser from "./pages/PathChooser";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Welcome from "./pages/Welcome";
import Dashboard from "./pages/Dashboard";
import NewProfile from "./pages/NewProfile";
import ProfileDetail from "./pages/ProfileDetail";
import ChapterEditor from "./pages/ChapterEditor";
import ReminisceStart from "./pages/ReminisceStart";
import ReminiscePlayer from "./pages/ReminiscePlayer";
import Admin from "./pages/Admin";
import RevenueModel from "./pages/RevenueModel";
import FontShootout from "./pages/admin/FontShootout";
import JohnsDemo from "./pages/JohnsDemo";
import Research from "./pages/Research";
import PartnersEOI from "./pages/PartnersEOI";
import Tutorial from "./pages/Tutorial";
import { ScrollToHash } from "./components/ScrollToHash";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <ScrollToHash />
                    <Routes>
                        <Route path="/" element={<LandingUnified />} />
                        <Route path="/chooser" element={<PathChooser />} />
                        <Route path="/adults" element={<Landing />} />
                        <Route path="/kids" element={<LandingKids />} />
                        <Route path="/sign-up" element={<SignUp />} />
                        <Route path="/sign-in" element={<SignIn />} />
                        <Route path="/welcome" element={<Welcome />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/profiles/new" element={<NewProfile />} />
                        <Route path="/profiles/:id" element={<ProfileDetail />} />
                        <Route path="/profiles/:id/chapter/:slug" element={<ChapterEditor />} />
                        <Route path="/profiles/:id/reminisce" element={<ReminisceStart />} />
                        <Route path="/profiles/:id/reminisce/play" element={<ReminiscePlayer />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/admin/model" element={<RevenueModel />} />
                        <Route path="/admin/font-shootout" element={<FontShootout />} />
                        <Route path="/demo/:slug" element={<JohnsDemo />} />
                        <Route path="/research" element={<Research />} />
                        <Route path="/partners" element={<PartnersEOI />} />
                        <Route path="/tutorial" element={<Tutorial />} />
                    </Routes>
                    <Toaster
                        position="top-center"
                        offset={88}
                        toastOptions={{
                            style: {
                                background: "#FFFFFF",
                                color: "#2D2B2A",
                                border: "1px solid #E5E1D8",
                                fontFamily: "Manrope, sans-serif",
                            },
                        }}
                    />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
